import React, { useState } from "react";
import styled from "styled-components";
import { rgba } from "polished";
import axios from "axios";
import Slider from "rc-slider";
const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 4rem;
`;
const StyledSliderWrapper = styled.div`
  position: relative;
  margin-right: 1rem;
  flex: 1 1 auto;
`;
const StyledSliderLabel = styled.div`
  position: absolute;
  top: -19px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  white-space: nowrap;
  font-size: 0.625rem;
  color: ${p => p.theme.colorLabel};
`;
const StyledSlider = styled(Slider)`
  & .rc-slider-rail,
  & .rc-slider-track {
    height: 10px;
    border-radius: 5px;
  }

  & .rc-slider-rail {
    background: ${rgba("black", 0.05)};
  }

  & .rc-slider-track {
    background: #a9a9a9;
  }

  & .rc-slider-handle {
    width: 28px;
    height: 28px;
    top: 0;
    background: #747474;
    border: #747474;
    box-shadow: 0px 0px 6px ${rgba("black", 0.12)};
  }
`;
const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.825rem;
  width: 120px;
  height: 2.5rem;
  border-radius: ${p => p.theme.borderRadius};
  white-space: nowrap;
  background: ${p => p.theme.colorSuccess};
  color: ${p => p.theme.colorSuccessText};
`;

const Wrapper = ({
  onError,
  currencySymbol
}) => {
  const [amount, setAmount] = useState(5);

  const depositFonix = async () => {
    try {
      const res = await axios.get(`/fonix/session?amount=${amount * 100}`);
      window.open(res?.data?.data?.payment_url);
    } catch ({
      response
    }) {
      onError(response);
    }
  };

  const handleChange = e => {
    setAmount(e);
  };

  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(StyledSliderWrapper, null, /*#__PURE__*/React.createElement(StyledSliderLabel, null, "Slide your amount"), /*#__PURE__*/React.createElement(StyledSlider, {
    min: 1,
    max: 10,
    step: 1,
    value: amount,
    onChange: handleChange
  })), /*#__PURE__*/React.createElement(StyledButton, {
    onClick: depositFonix
  }, "Deposit ", currencySymbol, amount));
};

export default Wrapper;